import { render, staticRenderFns } from "./CategorySentimentTrendsChart.vue?vue&type=template&id=2dea6ca8&scoped=true&"
import script from "./CategorySentimentTrendsChart.vue?vue&type=script&lang=js&"
export * from "./CategorySentimentTrendsChart.vue?vue&type=script&lang=js&"
import style0 from "./CategorySentimentTrendsChart.vue?vue&type=style&index=0&id=2dea6ca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dea6ca8",
  null
  
)

export default component.exports